import api, { ResponseCallback } from '../services/api.service'

export interface UnitData {
  id: number
  name: string
}

const routes = {
  list: '/units'
}

export default {
  list (callback: ResponseCallback<UnitData[]>) {
    api.get(routes.list, {}, callback)
  }
}
